import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { IoClose, IoTime } from "react-icons/io5";
import { fetchApi } from "../../../utlis/axios";
import {
  FaChevronDown,
  FaChevronUp,
  FaSortAmountDown,
  FaUserCircle,
} from "react-icons/fa";
import Calendar from "./Calendar";
import RichTextEditor1 from "./RichTextEditor1";
import { addToast } from "../../../Redux/Slices/toast-slice";
import { Link } from "react-router-dom";
import { RiEdit2Fill } from "react-icons/ri";
import { TbRefresh } from "react-icons/tb";
import { FaCalendarDays } from "react-icons/fa6";
import { GoMilestone } from "react-icons/go";
import loader from '../../../assets/loading-gif.gif'
import Loader from "../../Loader/Loader";

const TicketModal = ({
  setTicketModal,
  openedProject,
  ticketStatus,
  updateTickets,
  setTickets,
  newTicketColumnId,
  editingTicket,
  handleUpdateTicket,
  setEditingTickt,
  isTicketLoading,  getTickets
}) => {
  const { theme } = useSelector((state) => state.theme);
  const users = useSelector((state) => state.allUsers?.filterUsers);
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth || {});
  const [piortyDropdown, setPiortyDropdown] = useState(false);
  const [priorityValue, setPriorityValue] = useState(editingTicket?.priority || "high");
  const piortyOptions = ["low", "medium", "high"];
  const [milestones, setMilestones] = useState([]);
  const [selctedMilestone, setSelectedMilestone] = useState(editingTicket?.milestone?.id || "");
  const [creating, setCreating] = useState(false);
  const [milestoneDropDown, setMilestoneDropDown] = useState(false);
  const [selectedUser, setSelectedUser] = useState(editingTicket?.developer?.id || "");
  const [typeDropDown, setTypeDropDown] = useState(false);
  const [ticketData, setTicketData] = useState({
    title: editingTicket?.title || "",
    sprint: editingTicket?.sprint || "",
    description: editingTicket?.description || "",
    time_allotted: editingTicket?.time_allotted || "",
    priority: editingTicket?.priority || priorityValue,
    type: editingTicket?.type || "",
    started_at: editingTicket?.started_at || Date.now(),
    milestone: editingTicket?.milestone?.id || "",
    attachment: editingTicket?.attachment || [],
  });
  const [calendarDropdown, setCalendarDropdown] = useState(false);
  const [ticketsComment, setTicketsComments] = useState([]);
  const typeOptions = [
    { value: "bug", label: "bug" },
    { value: "task", label: "task" },
    { value: "story", label: "story" },
    { value: "epic", label: "epic" },
    { value: "sub_task", label: "sub task" },
    { value: "spike", label: "spike" },
    { value: "story_point", label: "story point" },
    { value: "improvement", label: "improvement" },
    { value: "change_request", label: "change request" },
    { value: "new_feature", label: "new feature" },
    { value: "incident", label: "incident" },
    { value: "service_request", label: "service request" },
    { value: "problem", label: "problem" },
    { value: "change", label: "change" },
    { value: "support_ticket", label: "support ticket" },
    { value: "test_case", label: "test_case" },
    { value: "requirement", label: "requirement" },
    { value: "deployment", label: "deployment" },
  ];

   const { nextPage, } = useSelector(
      (state) => state?.allUsers || {}
    );
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const [next, setNext] = useState(null);
    const [usersList, setUsersList] = useState([]);
    const dropdownRef = useRef(null);
    const [dropdownRefs] = useState({
      priority: useRef(null),
      type: useRef(null),
      calendar: useRef(null),
      milestone: useRef(null),
      user: useRef(null)
    });

  const getMilestone = async () => {
    try {
      const res = await fetchApi.get(
        `/project-milestones/?project=${openedProject}`,
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );
      if (res.status === 200) {
        setMilestones(res.data.results);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    }
  };
  let milestoneFetched = useRef(false);
  useEffect(() => {
    if (milestoneFetched.current) return;
    milestoneFetched.current = true;
    getMilestone();
  }, []);
  function formatToISO(date) {
    const isoString = new Date(date).toISOString(); // Returns date in ISO format (e.g., 2023-01-20T15:45:00.000Z)
    return isoString;
  }

  const handleSubmit = async () => {
    if (
      !ticketData.title ||
      !ticketData.sprint ||
      !ticketData.description ||
      !ticketData.time_allotted ||
      !ticketData.type
    ) {
      dispatch(addToast({ message: "Please fill all fields", type: "warn" }));
      return;
    } else if (!priorityValue) {
      dispatch(addToast({ message: "Please select priority", type: "warn" }));
      return;
    } else if (!selctedMilestone) {
      dispatch(addToast({ message: "Please select milestone", type: "warn" }));
      return;
    } else if (!selectedUser) {
      dispatch(addToast({ message: "Please select one user", type: "warn" }));
      return;
    } else {
      setCreating(true);
      try {
        const startingDate = formatToISO(ticketData.started_at);
        const formData = new FormData();
        formData.append("title", ticketData.title);
        formData.append("sprint", ticketData.sprint);
        formData.append("description", ticketData.description);
        formData.append("time_allotted", ticketData.time_allotted);
        formData.append("started_at", startingDate);
        formData.append("priority", priorityValue);
        formData.append("type", ticketData.type);
        formData.append("ticket_status", newTicketColumnId);
        formData.append("project", openedProject);
        formData.append("milestone", selctedMilestone);
        formData.append("developer", selectedUser);

        if (ticketData.attachment?.length > 0) {
          ticketData.attachment.forEach((file, index) => {
            formData.append(`attachment[${index}]`, file);
          });
        }

         if (editingTicket) {
          // If editing, call handleUpdateTicket
          const newformData = new FormData();
        newformData.append("title", ticketData.title);
        newformData.append("sprint", ticketData.sprint);
        newformData.append("description", ticketData.description);
        newformData.append("time_allotted", ticketData.time_allotted);
        newformData.append("started_at", startingDate);
        newformData.append("priority", priorityValue);
        newformData.append("type", ticketData.type);
        newformData.append("ticket_status", editingTicket?.ticket_status?.id);
        newformData.append("project", openedProject);
        newformData.append("milestone", selctedMilestone);
        newformData.append("developer", selectedUser);
          await handleUpdateTicket(newformData);
        } else {
          // If creating new ticket
          const res = await fetchApi.post("/project-tickets/", formData, {
            headers: {
              Authorization: `Bearer ${userInfo.access_token}`,
            },
          });

          if (res.status === 201) {
           getTickets(openedProject)
            dispatch(
              addToast({
                message: "Ticket created successfully",
                type: "success",
              })
            );
            setTicketModal(false);
          }
        }
      } catch (error) {
        dispatch(addToast({ message: error.message, type: "error" }));
      } finally {
        setCreating(false);
      }
    }
  };

  // Initialize usersList with users from Redux
  useEffect(() => {
    setUsersList(users);
    setNext(nextPage);
  }, [users, nextPage]);

  
  const handleUsersScroll = async (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const scrollThreshold = 50; // pixels from bottom to trigger load

    // Check if we're near the bottom and there's more to load
    if (scrollHeight - (scrollTop + clientHeight) < scrollThreshold && next && !isLoading) {
      await fetchNextUsers(next);
    }
  };

  const fetchNextUsers = async (url) => {
    if (!url || isLoading) return;
    
    setIsLoading(true);
    try {
      const res = await fetchApi.get(url, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 200) {
        setUsersList(prev => [...prev, ...res.data.results]);
        setNext(res.data.next);
      }
    } catch (error) {
      console.error('Error fetching more users:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async (e) => {
    if (e.key === 'Enter') {
      setIsSearching(true);
      try {
        const res = await fetchApi.get(`users/?search=${searchQuery}`, {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        });
        if (res.status === 200) {
          setUsersList(res.data.results);
          setNext(res.data.next);
        }
      } catch (error) {
        console.error('Search error:', error);
      } finally {
        setIsSearching(false);
      }
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    
    if (!value.trim()) {
      setUsersList(users);
      setNext(nextPage);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check priority dropdown
      if (dropdownRefs.priority.current && !dropdownRefs.priority.current.contains(event.target)) {
        setPiortyDropdown(false);
      }
      
      // Check type dropdown
      if (dropdownRefs.type.current && !dropdownRefs.type.current.contains(event.target)) {
        setTypeDropDown(false);
      }
      
      // Check calendar dropdown
      if (dropdownRefs.calendar.current && !dropdownRefs.calendar.current.contains(event.target)) {
        setCalendarDropdown(false);
      }
      
      // Check milestone dropdown
      if (dropdownRefs.milestone.current && !dropdownRefs.milestone.current.contains(event.target)) {
        setMilestoneDropDown(false);
      }

      // Check user dropdown
      if (dropdownRefs.user.current && !dropdownRefs.user.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="customFont">
      <>
        {/* Overlay */}
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[1000]"></div>

        <div className="w-full h-full max-h-[100vh] overflow-y-scroll z-[1010] inset-0 fixed px-4 py-4 ">
          {/* Modal Content */}
          <div className="flex min-h-full items-center justify-center">
            <div className=" flex items-center justify-center w-full ">
              <div
                className={` p-6 rounded-lg shadow-lg max-w-screen-md  w-full relative  ${
                  theme === "dark"
                    ? "bg-darkMode text-white"
                    : "bg-white text-black"
                }`}
              >
                <div className="flex justify-between">
                  <div className="flex gap-2 items-center">
                    <div
                      className={`p-1 rounded-full ${
                        theme === "dark"
                          ? " bg-gray-700 text-white"
                          : "bg-gray-300 text-black"
                      }`}
                    >
                      <IoIosArrowForward className="w-5 h-5" />
                    </div>
                    <h2 className="text-xl font-semibold">
                      {editingTicket ? "Update Ticket" : "New Ticket"}
                    </h2>
                  </div>
                  <div
                    className={`p-1 rounded-full ${
                      theme === "dark"
                        ? " bg-gray-700 text-white"
                        : "bg-gray-300 text-black"
                    }`}
                  >
                    <IoClose
                      className="w-6 h-6"
                      onClick={() => {
                        setTicketModal(false);
                        setEditingTickt(null)
                      }}
                    />
                  </div>
                </div>
                <hr
                  className={`mt-4 ${
                    theme === "dark" ? "text-white" : "text-black"
                  }`}
                /> 
                {(editingTicket && isTicketLoading) ? <div className="flex justify-center items-center min-w-scren-sm min-h-[40vh"><Loader/></div> :
                <div>
                <form className=" my-4">
                  <div className="grid grid-cols-2  gap-6 mt-3">
                    <div className="w-full">
                      <label
                        htmlFor=""
                        className="font-semibold  flex items-center gap-1 text-base"
                      >
                        <RiEdit2Fill className="w-5 h-5" />
                        Title <span className="text-red-600 text-xl font-semibold">*</span>
                      </label>
                      <input
                        type="text"
                        className={`text-base font-normal mt-2 p-2 bg-transparent outline-none w-full rounded-[10px] border ${
                          theme === "dark"
                            ? "placeholder:text-gray-600 border-gray-600 "
                            : "placeholder:text-gray-400 border-[#555657]"
                        }`}
                        value={ticketData.title}
                        onChange={(e) => {
                          setTicketData({
                            ...ticketData,
                            title: e.target.value,
                          });
                        }}
                        placeholder="Add title"
                      />
                    </div>
                    <div className="w-full">
                      <label
                        htmlFor=""
                        className="font-semibold  flex items-center gap-1 text-base"
                      >
                        <TbRefresh className="w-5 h-5" />
                        Sprint <span className="text-red-600 text-xl font-semibold">*</span>
                      </label>
                      <input
                        type="text"
                        className={`text-base font-normal mt-2 p-2 bg-transparent outline-none w-full rounded-[10px] border ${
                          theme === "dark"
                            ? "placeholder:text-gray-600 border-gray-600 "
                            : "placeholder:text-gray-400 border-[#555657]"
                        }`}
                        value={ticketData.sprint}
                        onChange={(e) => {
                          setTicketData({
                            ...ticketData,
                            sprint: e.target.value,
                          });
                        }}
                        placeholder="Sprint"
                      />
                    </div>
                    <div className="w-full ">
                      <label
                        htmlFor=""
                        className="font-semibold  flex items-center gap-1 text-base"
                      >
                        <RiEdit2Fill className="w-5 h-5" />
                        Type <span className="text-red-600 text-xl font-semibold">*</span>
                      </label>
                      <div ref={dropdownRefs.type} className="relative w-full">
                        <div
                          className={`${
                            theme === "dark" ? " text-white" : " text-black"
                          }  px-2 py-2 cursor-pointer flex justify-between items-center text-base font-normal mt-2 bg-transparent outline-none w-full rounded-[10px] border ${
                          theme === "dark"
                            ? "placeholder:text-gray-600 border-gray-600 "
                            : "placeholder:text-gray-400 border-[#555657]"
                        }`}
                          onClick={() => setTypeDropDown(!typeDropDown)}
                        >
                          <span className=" capitalize">
                            {ticketData.type
                              ? typeOptions.find(
                                  (item) => item.value === ticketData.type
                                )?.label || "Select type"
                              : "Select type"}
                          </span>
                          {typeDropDown ? (
                            <FaChevronUp className="w-4 h-4 " />
                          ) : (
                            <FaChevronDown className="w-4 h-4" />
                          )}
                        </div>

                        {typeDropDown && (
                          <div
                            className={`absolute top-full left-0 mt-2 w-full  max-h-48 overflow-y-auto rounded-md z-10 border shadow-2xl ${
                              theme === "dark"
                                ? "bg-[#212529] border-[#555657]"
                                : "bg-[#F2F4F7] border-[#9A9F9A]"
                            } `}
                          >
                            {typeOptions.map((option) => (
                              <div
                                key={option.value} // Fix: Correct key usage
                                className={`flex items-center px-3 py-2 hover:bg-gray-200 cursor-pointer ${
                                  theme === "dark" ? "hover:bg-gray-700" : ""
                                }`}
                                onClick={() => {
                                  setTicketData((prev) => ({
                                    ...prev,
                                    type: option.value, // Fix: Correct way to update ticketData
                                  }));
                                  setTypeDropDown(false);
                                }}
                              >
                                <span className="capitalize">
                                  {option.label}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full">
                      <label
                        htmlFor=""
                        className="font-semibold  flex items-center gap-1 text-base"
                      >
                        <IoTime className="w-5 h-5" />
                        Alloted Time <span className="text-red-600 text-xl font-semibold">*</span>
                      </label>
                      <input
                        type="number"
                        className={`text-base font-normal mt-2 p-2 bg-transparent outline-none w-full rounded-[10px] border ${
                          theme === "dark"
                            ? "placeholder:text-gray-600 border-gray-600 "
                            : "placeholder:text-gray-400 border-[#555657]"
                        }`}
                        value={ticketData.time_allotted}
                        onChange={(e) => {
                          setTicketData({
                            ...ticketData,
                            time_allotted: e.target.value,
                          });
                        }}
                        placeholder="Enter allotted time"
                      />
                    </div>
                    <div className="w-full">
                      <label
                        htmlFor=""
                        className="font-semibold  flex items-center gap-1 text-base"
                      >
                        <FaCalendarDays className="w-5 h-5" />
                        Start Date <span className="text-red-600 text-xl font-semibold">*</span>
                      </label>
                      <div ref={dropdownRefs.calendar} className="w-full relative mt-1">
                        <span
                          className={`w-full flex justify-between items-center ${
                            ticketData.started_at.length > 0
                              ? ""
                              : theme === "dark"
                              ? "text-gray-600"
                              : "text-gray-400"
                          } text-base font-normal mt-2 p-2 bg-transparent outline-none w-full rounded-[10px] border ${
                          theme === "dark"
                            ? "placeholder:text-gray-600 border-gray-600 "
                            : "placeholder:text-gray-400 border-[#555657]"
                        }`}
                          onClick={() => setCalendarDropdown(!calendarDropdown)}
                        >
                          {ticketData.started_at.length > 0
                            ? ticketData.started_at
                            : "Select Start Date"}
                          {calendarDropdown ? (
                            <FaChevronUp className="w-4 h-4 " />
                          ) : (
                            <FaChevronDown className="w-4 h-4" />
                          )}
                        </span>
                        {calendarDropdown && (
                          <Calendar
                            theme={theme}
                            onDateSelect={(date) => {
                              ticketData.started_at = date;
                              setCalendarDropdown(false);
                            }}
                          />
                        )}
                      </div>
                    </div>

                    <div className="w-full">
                      <label
                        htmlFor=""
                        className="font-semibold  flex items-center gap-1 text-base"
                      >
                        <FaSortAmountDown className="w-5 h-5" />
                        Piriority <span className="text-red-600 text-xl font-semibold">*</span>
                      </label>
                      <div ref={dropdownRefs.priority} className="relative w-full">
                        <div
                          className={`${
                            theme === "dark"
                              ? "border-gray-600 text-white"
                              : "border-gray-400 text-black"
                          }  cursor-pointer flex justify-between items-center text-base font-normal mt-2 p-2 bg-transparent outline-none w-full rounded-[10px] border ${
                          theme === "dark"
                            ? "placeholder:text-gray-600 border-gray-600 "
                            : "placeholder:text-gray-400 border-[#555657]"
                        }`}
                          onClick={() => setPiortyDropdown(!piortyDropdown)}
                        >
                          <span>{priorityValue}</span>
                          {piortyDropdown ? (
                            <FaChevronUp className="w-4 h-4 " />
                          ) : (
                            <FaChevronDown className="w-4 h-4" />
                          )}
                        </div>
                        {piortyDropdown && (
                          <div
                            className={`absolute top-full left-0 mt-2 w-full shadow-lg rounded-md z-10 border ${
                              theme === "dark"
                                ? "bg-[#212529] border-[#555657]"
                                : "bg-[#F2F4F7] border-[#9A9F9A]"
                            }`}
                          >
                            {piortyOptions.map((option) => (
                              <div
                                key={option}
                                className={`flex items-center px-3 py-2 hover:bg-gray-200 cursor-pointer ${
                                  theme === "dark" ? "hover:bg-gray-700" : ""
                                }`}
                                onClick={() => {
                                  setPriorityValue(option);
                                  setPiortyDropdown(false);
                                }}
                              >
                                {option.icon}
                                <span className="capitalize">{option}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full ">
                      <label
                        htmlFor=""
                        className="font-semibold  flex items-center gap-1 text-base"
                      >
                        <FaUserCircle className="w-5 h-5" />
                        Assigned User <span className="text-red-600 text-xl font-semibold">*</span>
                      </label>
                      <div ref={dropdownRefs.user} className="relative mt-2 w-full">
                        <div
                          className={`border rounded-[10px] gap-4 flex items-center justify-between p-2 min-w-[200px] w-full bg-transparent cursor-pointer ${
                            theme === "dark"
                              ? " border-[#555657]"
                              : " border-[#9A9F9A]"
                          }`}
                          onClick={() => setIsOpen(!isOpen)}
                        >
                          <span>
                            {selectedUser
                              ? usersList.find((item)=> item.id === selectedUser)?.first_name + " " + usersList.find((item)=> item.id === selectedUser)?.last_name
                              : "Select User"}
                          </span>
                          <IoIosArrowDown className="w-4 h-4" />
                        </div>
                        {isOpen && (
                          <div
                            className={`z-10 absolute mt-1 bottom-[43px] w-full border overflow-auto shadow-lg rounded-[10px] max-h-[280px] ${
                              theme === "dark"
                                ? "bg-[#212529] border-[#555657]"
                                : "bg-[#F2F4F7] border-[#9A9F9A]"
                            }`}
                            onScroll={handleUsersScroll}
                          >
                            <div className="flex items-center justify-between w-full">
                              <input 
                                type="text"  
                                className={`p-2 pl-8 bg-transparent border-b outline-none w-full ${
                                  theme === "dark" ? "border-[#555657]" : "border-[#D8D8D8]"
                                }`}
                                value={searchQuery}
                                onChange={handleSearchChange}
                                onKeyDown={handleSearch}
                                placeholder="Search users..."
                              />
                              {isSearching && (
                                <div className="absolute left-2 top-1/2 -translate-y-1/2">
                                  <img src={loader} alt="Searching..." className="w-4 h-4" />
                                </div>
                              )}
                            </div>
                            {usersList?.map((user) => (
                              <div
                                key={user.id}
                                className={`p-2 cursor-pointer hover:bg-opacity-10 hover:bg-gray-500 flex items-center gap-2 ${
                                  selectedUser?.id === user.id ? "bg-opacity-10 bg-gray-500" : ""
                                } ${
                                  theme === "dark"
                                    ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all"
                                    : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all"
                                }`}
                                onClick={() => {
                                 setSelectedUser(user?.id)
                                  setIsOpen(false);
                                }}
                              >
                                {user.picture ? (
                                  <img 
                                    src={user.picture} 
                                    alt={`${user.first_name}`}
                                    className="w-6 h-6 rounded-full object-cover"
                                  />
                                ) : (
                                  <FaUserCircle className="w-6 h-6 text-gray-400" />
                                )}
                                <span>
                                  {user.first_name} {user.last_name}
                                </span>
                              </div>
                            ))}
                            {isLoading && (
                              <div className="flex justify-center p-2">
                                <img src={loader} alt="Loading..." className="w-6 h-6" />
                              </div>
                            )}
                            {!next && usersList.length > 0 && (
                              <div className="text-center p-2 text-sm text-gray-400">
                                No more users to load
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" w-full">
                      <label
                        htmlFor=""
                        className="font-semibold  flex items-center gap-1 text-base"
                      >
                        <GoMilestone className="w-5 h-5" />
                        Milestone <span className="text-red-600 text-xl font-semibold">*</span>
                      </label>
                      <div ref={dropdownRefs.milestone} className="relative w-full">
                        <div
                          className={`text-base font-normal mt-2 p-2 bg-transparent outline-none w-full rounded-[10px] border ${
                          theme === "dark"
                            ? "placeholder:text-gray-600 border-gray-600 "
                            : "placeholder:text-gray-400 border-[#555657]"
                        }  cursor-pointer flex justify-between items-center ${
                            selctedMilestone.length > 0
                              ? ""
                              : theme === "dark"
                              ? "text-gray-600"
                              : "text-gray-400"
                          }`}
                          onClick={() =>
                            setMilestoneDropDown(!milestoneDropDown)
                          }
                        >
                          <span>
                            {milestones?.find(
                              (milestone) => milestone.id === selctedMilestone
                            )?.title || "Select Milestone"}
                          </span>
                          {milestoneDropDown ? (
                            <FaChevronUp className="w-4 h-4 " />
                          ) : (
                            <FaChevronDown className="w-4 h-4" />
                          )}
                        </div>
                        {milestoneDropDown && (
                          <div
                            className={`absolute top-full left-0 p-2 mt-2 w-full shadow-lg rounded-md z-10 border ${
                              theme === "dark"
                                ? "bg-[#212529] border-[#555657]"
                                : "bg-[#F2F4F7] border-[#9A9F9A]"
                            }`}
                          >
                            {milestones.length <= 0 ? (
                              <Link
                                to={`/dashboard/project/${openedProject}`}
                                className=" cursor-pointer "
                              >
                                Create Milestone
                              </Link>
                            ) : (
                              milestones?.map((option) => (
                                <div
                                  key={option.id} // Use a unique identifier like option.id
                                  className={`flex items-center px-3 py-2 hover:bg-gray-200 cursor-pointer ${
                                    theme === "dark" ? "hover:bg-gray-700" : ""
                                  }`}
                                  onClick={() => {
                                    setSelectedMilestone(option.id);
                                    setMilestoneDropDown(false);
                                  }}
                                >
                                  {option.icon}
                                  <span className="capitalize">
                                    {option.title}
                                  </span>
                                </div>
                              ))
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <label htmlFor="" className="font-semibold mt-4 text-lg">
                    Description
                  </label>
                  <RichTextEditor1
                    setProjectData={setTicketData}
                    projectData={ticketData}
                  />
                </form>
                <div className="flex gap-6 justify-center items-center pt-4">
                  <button
                    className={` border rounded-3xl px-3 py-2 bg-transparent w-1/3  ${
                      theme === "dark" ? "border-gray-700" : "border-gray-500"
                    }`}
                    onClick={() => {
                      setTicketModal(false);
                      setEditingTickt(null)
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="heroButton w-1/3 font-medium"
                    disabled={creating}
                    onClick={handleSubmit}
                  >
                    {creating ? (editingTicket ? "Updating..." : "Creating...") : (editingTicket ? "Update Ticket" : "Create Ticket")}
                  </button>
                </div>
                </div> }
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default TicketModal;
